import React from 'react';
import {Box, Typography} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

function ProjectQuestions({questions}) {
    return (
        <Box sx={{display: 'flex', flexDirection: 'column', gap: '12px', mt: '24px'}}>
            <Typography variant="subtitle1" fontWeight="bold">Key Questions:</Typography>
            {questions.map((q, i) => (
                <Box key={i} sx={{display: 'flex', alignItems: 'flex-start', gap: '8px'}}>
                    <HelpOutlineIcon sx={{color: 'text.secondary', mt: '2px', flexShrink: 0}} fontSize="small"/>
                    <Typography variant="body2">{q}</Typography>
                </Box>
            ))}
        </Box>
    );
}

export default ProjectQuestions;
